import { render, staticRenderFns } from "./HighlightingFacadeIcon.vue?vue&type=template&id=6a755d42"
import script from "./HighlightingFacadeIcon.vue?vue&type=script&lang=js"
export * from "./HighlightingFacadeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports